import React from 'react';

import camelCase from 'lodash/camelCase';

import Input from './input';

import type { CustomField } from 'bundles/apex/custom_fields/types';
import type { RecordWithCustomFields, Value } from './types';

interface Props {
  customFields: CustomField[],
  record: RecordWithCustomFields;
  onChange?: (changes: Record<string, Value>) => void;
}

export default function ApexCustomFieldInputs({ customFields, record, onChange }: Props) {
  return <>
    {customFields.map(customField => (
      <Input
        customField={customField}
        key={customField.name}
        name={camelCase(customField.name)}
        value={record[camelCase(customField.name)]}
        onChange={onChange}
      />
    ))}
  </>;
}
